module.exports = __webpack_public_path__ + "img/light-f-fm-Path 47 Copy@3x.ba42c7f5.png";